var _rect, _path, _circle, _text, _text2, _text3, _circle2, _text4, _text5, _text6, _circle3, _text7, _text8, _text9, _circle4, _text0, _text1, _text10, _rect2, _text11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreDailyCheckInCheckOutShiftTimelineDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1040,
    height: 250,
    viewBox: "0 0 1040 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore desktop shift evidence timeline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1040,
    height: 250,
    rx: 28,
    fill: "#FFFFFF",
    stroke: "#D2E1F2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 80H912",
    stroke: "#D2E1F2",
    strokeWidth: 3,
    strokeDasharray: "5 8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 80,
    r: 24,
    fill: "#087CFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 86,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "01")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 139,
    fill: "#087CFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "CHECK IN")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 172,
    fill: "#07152A",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Driver + asset linked")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 80,
    r: 24,
    fill: "#FF2775"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 389,
    y: 86,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "02")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 389,
    y: 139,
    fill: "#FF2775",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "CAPTURE")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 389,
    y: 172,
    fill: "#07152A",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Walk-around + odometer")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 80,
    r: 24,
    fill: "#087CFF"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 86,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "03")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 139,
    fill: "#087CFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "OPERATE")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 172,
    fill: "#07152A",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Shift activity recorded")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 911,
    cy: 80,
    r: 24,
    fill: "#FF2775"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 911,
    y: 86,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "04")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 911,
    y: 139,
    fill: "#FF2775",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "CHECK OUT")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 911,
    y: 172,
    fill: "#07152A",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "New evidence compared")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 207,
    width: 928,
    height: 1,
    fill: "#D2E1F2"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 231,
    fill: "#536985",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 650
  }, "One shift report \xB7 two evidence points \xB7 visible change history")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreDailyCheckInCheckOutShiftTimelineDesktop);
export default __webpack_public_path__ + "static/media/fleetcore-daily-check-in-check-out-shift-timeline-desktop.c14a618642c57f7aded3fd44a43c4fa3.svg";
export { ForwardRef as ReactComponent };